<template lang="html">
  
<div class="root h-100" id="new-front">
     
    <!-- Background Start -->
    <div class="fixed-background" v-if="!loading"></div>
    <!-- Background End -->
    <div class="container-fluid p-0 h-100 position-relative" v-if="!loading">
      <div class="row g-0 h-100">
      <!-- Left Side Start -->
      <div class="offset-0 col-12 d-none d-lg-flex offset-md-1 col-lg h-lg-100">
        <div class="min-h-100 d-flex align-items-center">
          <div class="w-100 w-lg-75 w-xxl-50">
            <div>
              <div class="mb-5">
                <h1 class="display-3 text-white">{{ label }}</h1>

              </div>
              <p class="h3 text-white lh-1-5 mb-5">
                {{ mainText }} <br>

              </p>
              <div class="mb-5">
                <p class="h6 text-white lh-1-5 mb-5">Une question ?<br>Contactez-nous au <a :href="`tel:${phone.replace(/\s+/g, '')}`" class="text-white underline-link">{{ phone }}</a> ou <a :href="`mailto:${email}`" class="text-white underline-link">{{ email  }}</a></p>

              </div>
              <div class="mb-5">
                <a class="btn btn-lg btn-outline-white" :href="`${siteLinkText}`" target="_blank">Voir notre site</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Left Side End -->

      <!-- Right Side Start -->
      <div class="col-12 col-lg-auto h-100 pb-4 px-4 pt-0 p-lg-0">
        <div class="sw-lg-70 min-h-100 bg-foreground d-flex justify-content-center align-items-center shadow-deep py-5 full-page-content-right-border">
          <div class="sw-lg-50 px-5">
            <div class="sh-11 mb-3">
              <a href="index.php">
                <div :style="{ backgroundImage: 'url(' + logoUrl + ')' }" class="logo-default"></div>
              </a>
            </div>

            <h5 class="mb-0 lh-1-5 mb-5">Bienvenue, merci de vous identifier pour accéder à votre extranet</h5>


            <div>
              <form @keypress.13.prevent v-on:keyup.enter="login" @submit.prevent.native translate="no">

              <div class="mb-3 filled form-group tooltip-end-top">
                <i data-acorn-icon="user"></i>
                <input v-model="username" class="form-control" :placeholder="placholderLogin" translate="no" lang="fr" type="text" />
              </div>
              <div class="mb-3 filled form-group tooltip-end-top">
                <i data-acorn-icon="lock-off"></i>
                <input v-model="password" class="form-control pe-7" type="password" placeholder="Mot de passe" />
              </div>
              <!--
              <div class="mb-3">
                <a href="#" data-bs-toggle="modal" data-bs-target="#lostModal">Mot de passe oublié ?</a>
              </div>
              -->
              <a v-on:click="login" class="btn btn-lg btn-primary" translate="no">Se connecter</a>

              </form>
              <br>
              <article style="height:0px;" class="message is-danger" v-if="error!=''">
                <div class="message-body" >
                  {{error}}
                </div>
              </article>
              <br>
              <br>
              Vous n'arrivez pas à vous connecter ? <br>Vous avez oublié votre Mot de Passe ? <br>Contactez l'équipe au {{ phone }} ou sur <a :href="`mailto:${email}`">{{ email }}</a>
            </div>
          </div>
        </div>
      </div>
      <!-- Right Side End -->
    </div>


  <div class="modal modal-right large fade" id="lostModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Mot de passe oublié</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body h-100 d-flex justify-content-center align-items-center">
          <div class="sw-lg-70 min-h-100 bg-foreground d-flex justify-content-center align-items-center py-5 full-page-content-right-border">
            <div class="sw-lg-50 px-5">
              <div class="sh-11 mb-3">
                <a href="index.php">
                  <div :style="{ backgroundImage: 'url(' + logoUrl + ')' }" class="logo-default"></div>
                </a>
              </div>

              <h5 class="mb-0 lh-1-5 mb-5">Merci d'entrer votre mail, nous vous l'enverrons sur votre messagerie</h5>

              <div class="mb-4 filled form-group tooltip-end-top">
                <i data-acorn-icon="email"></i>
                <input class="form-control" placeholder="Email" type="email" />
              </div>
              <a href="index.php" id="ResetPsw" class="btn btn-primary" data-bs-dismiss="modal" aria-label="Close">Envoyer le mot de passe</a>
              <a data-bs-dismiss="modal" aria-label="Close" class="btn btn-outline-primary">Annuler</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  </div>
</div>
</template>

<style>
  .loading{
      position:fixed;
      top:calc(50% - 10px);
      left:calc(50% - 50px);
      fint-size: 30px;
  }
</style>

<script>
import settings from '@/settings.coffee'
import TAG_NAME from '@/gql/queries/tagName.graphql'
import CONSULTANTS_STATS_FROM_VIEW from '@/gql/queries/consultantsStatsFromView.graphql'
import { gqlQuery } from '@/gqlClient.js'

export default {
  name: 'login',
  data() {
    return {
      loading: true,
      error: "",
      username: "",
      password: "",
      logoUrl: "",
      label: "",
      mainText: "",
      siteLinkText: "",
      phone: "",
      email: "",
      placholderLogin: "Login"
    };
  },
  methods: {
    async get_schema() {
      const tagResponse = await gqlQuery(TAG_NAME, {});
      this.$store.commit(
        'set_tag_name',
        JSON.parse(tagResponse.body.data.tag_name)
      );
      const statsResponse = await gqlQuery(CONSULTANTS_STATS_FROM_VIEW, {});
      this.$store.commit(
        'set_stats',
        statsResponse.body.data.get_consultants_stats_from_view
      );
    },
    async login() {
      this.error = "";
      const res = await this.$http.post(settings.authApiUrl, JSON.stringify({
        username: this.username,
        password: this.password
      }));
      console.log(res);
      if (res.body.status === "loggedin") {
        this.$store.dispatch('set_authenticated', res.body.profile);
        const to = this.$route.params.next;
        if (to) {
          this.$router.push({ path: to });
        } else {
          this.$router.push({ path: '/' });
        }
        await this.get_schema();
      } else {
        this.error = res.body.status;
      }
    },
    async getSetting() {
      this.error = "";
      const data = await this.$http.get(settings.backendUrl + "/admin/setting/");
      for (const s of data.body.settings) {
        if (s.slug === 'instance_logo') {
          this.logoUrl = settings.backendMediaUrl + s.file;
        }
        if (s.slug === 'instance_name') {
          this.label = s.value;
        }
        if (s.slug === 'instance_main_text') {
          this.mainText = s.value;
        }
        if (s.slug === 'instance_site_link') {
          this.siteLinkText = s.value;
        }
        if (s.slug === 'instance_phone') {
          this.phone = s.value;
        }
        if (s.slug === "instance_email") {
          this.email = s.value;
        }
      }
    }
  },
  async mounted() {
    setTimeout(() => {
      new AcornIcons().replace();
    }, 200);
    await this.getSetting();
    const data = await this.$http.get(settings.authApiUrl);
    this.$cookie.set('csrftoken', data.body.csrf);
    const subdata = await this.$http.post(settings.authApiUrl);
    if (subdata.body.status === "loggedin") {
      const to = this.$route.params.next;
      this.$store.dispatch('set_authenticated', subdata.body.profile);
      if (to) {
        this.$router.push({ path: to });
      } else {
        this.$router.push({ path: '/' });
      }
      await this.get_schema();
    } else {
      this.loading = false;
      this.$store.dispatch('set_authenticated', null);
    }
  }
}
</script>


<style scoped lang="css" >

</style>
